import React, {useEffect,  useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService"
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Botonera";
import IndicadorCredito from "./IndicadorCredito";
import EPagosSites from "../EPagosSites";
import BotoneraWithFooter from "./BotoneraWithFooter";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";

const EstacionamientoError = () => {

    const n = parseInt("716298462");
const formatted = n.toLocaleString('es-AR');
    const navigate=useNavigate();
      return (
        <section>
        <main> 
            <div class="row">
                <div class="col">
                    <img  style={{width: "60%", marginTop: "170px"}} src="./estacionamiento_error_02.svg"/>
                </div>
                </div>
              
            <div class="row">
                <div class="col indicationText" style={{marginLeft:"30px", marginRight: "30px"}}>
                    La funcionalidad de <span style={{color:"red"}}>estacionamiento </span>no est&aacute; disponible temporalmente. Por favor vuelva a intentarlo.
                </div>
            </div>
            
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClipShort" onClick={()=> navigate("/")}>Ir a Inicio</button>
                </div>
                </div>
            </div>
            </main></section>);
}

export default EstacionamientoError;